import { Activity } from "lucide-react";

export function EnginePulse({ pulse, evidence, analyzed }) {
  const evRunning = (evidence || []).filter(
    (e) => ["queued", "running"].includes(e.orchestration_status) || e.triage_status === "pending"
  ).length;
  const caseRunning = !!pulse?.running;
  const active = caseRunning || evRunning > 0;
  if (!active && !(pulse && pulse.total) && !analyzed) return null;

  const done = pulse?.done || 0;
  const total = pulse?.total || 0;
  const pct = total ? Math.round((done / total) * 100) : 0;

  return (
    <div data-testid="engine-pulse"
      className={`rounded-md border px-4 py-3 mb-4 flex items-center gap-3 transition-colors ${active ? "border-monk-blue/40 bg-monk-blue/5" : "border-white/10 bg-black/30"}`}>
      <span className="relative flex h-2.5 w-2.5 shrink-0">
        {active && <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-monk-blue opacity-60" />}
        <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${active ? "bg-monk-blue" : "bg-neutral-600"}`} />
      </span>
      <Activity className={`w-4 h-4 shrink-0 ${active ? "text-monk-blue" : "text-neutral-500"}`} />
      <div className="flex-1 min-w-0">
        <div className="text-[12px] font-mono text-neutral-200 truncate" data-testid="engine-pulse-label">
          {active ? "ENGINE ARRAY · ANALYZING" : "ENGINE ARRAY · READY"}
          {caseRunning && total ? ` · ${done}/${total} case engines` : ""}
          {evRunning ? ` · ${evRunning} in triage` : ""}
        </div>
        {caseRunning && total ? (
          <div className="h-1 mt-1.5 bg-white/10 rounded-full overflow-hidden">
            <div className="h-full bg-monk-blue transition-all duration-500" style={{ width: `${pct}%` }} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
